module.exports = __webpack_public_path__ + "img/area2_211021.f8b03e49.jpg";